<template>
  <div v-if="item.subMenuList">
    <template v-if="item.subMenuList.length == 0">
        <el-menu-item :index="item.path?item.path:item.number">
          <i :class="item.icon"></i>
          {{item.name}}
        </el-menu-item>
    </template>

    <el-submenu v-else :index="item.path?item.path:item.number">
      <template slot="title" >
        <i :class="item.icon"></i>
        {{item.name}}
      </template>

      <template v-for="child in item.subMenuList">
        <sidebar-item
          v-if="child.subMenuList&&child.subMenuList.length>0"
          :item="child"
          :key="child.path?child.path:child.number"/>
        <el-menu-item v-else :key="child.path" :index="child.path?child.path:child.number">
          <i :class="child.icon"></i>
          {{child.name}}
        </el-menu-item>
      </template>
    </el-submenu>
  </div>
</template>

<script>

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SidebarItem.vue